import CryptoJS from 'crypto-js'

// AES 加密密钥
const key = CryptoJS.enc.Utf8.parse('9d2b5f8a1e3c7d9b')

/**
 * @description Base64加密
 * @returns {string} Base64编码后的文本
 * @param content
 */
export function encrypt (content) {
  return CryptoJS.AES.encrypt(content, key, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  }).toString()
}

/**
 * @description Base64解密
 * @param {string} base64Text - Base64编码的文本
 * @returns {string} 解密后的文本
 */
export function decrypt (base64Text) {
  const parsedWordArray = CryptoJS.enc.Base64.parse(base64Text)
  return parsedWordArray.toString(CryptoJS.enc.Utf8)
}
